// extracted by mini-css-extract-plugin
module.exports = {"inputMask":"InputMaskField_inputMask__21P7L","empty":"InputMaskField_empty__1xzR3"};